export default __webpack_public_path__ + "static/medgas_panel_b.30d76be5467d8113138035b5b422d8bc.svg";